jQuery.noConflict();
jQuery(window).on('load', function(){
	//LAZY LOADING
	jQuery("img.lazy").lazyload({
	      effect: "fadeIn",
	      failure_limit : 7
	});
	//Carte OpenStreetMap
	if (jQuery('#omap').length ) {
		map = new OpenLayers.Map("omap");
		map.addLayer(new OpenLayers.Layer.OSM());
		var lonLat = new OpenLayers.LonLat( jQuery("#LongitudeOL").val() , jQuery("#LatitudeOL").val() )
		.transform(
			 new OpenLayers.Projection("EPSG:4326"), // transform from WGS 1984
		     map.getProjectionObject() // to Spherical Mercator Projection
		);
		var zoom=jQuery("#ZoomOL").val();
		if (zoom.length === 0) {
			zoom = 17;
		}
	    var markers = new OpenLayers.Layer.Markers( "Markers" );
	    map.addLayer(markers);
	    markers.addMarker(new OpenLayers.Marker(lonLat));
	    map.setCenter (lonLat, zoom);
	}
	//BX SLIDER
	if (jQuery('#sliderLien').length ) {
		jQuery('#sliderLien').bxSlider({
			  responsive: true,
			  stopAutoOnClick: true,
			  captions: true,
			  controls : false,
		      touchEnabled: false,
			  pager: true
		});
	}
	
	//Accessibilité
	if ( jQuery.cookie('dyslexic') == 'true'){
		jQuery("body").addClass( 'dyslexic' );
	}

	if (jQuery('a.dys').length ) {
		jQuery( "a.dys" ).click(function() {
			//alert("ok");
			jQuery("body").toggleClass( "dyslexic" );
			jQuery.cookie( 'dyslexic', jQuery("body").hasClass( "dyslexic" ), { expires: 7, path: '/' } );
		});	
	}

	if ( jQuery.cookie('contrast') == 'true'){
		jQuery("body").addClass( 'contrast' );
	}	
		if (jQuery('a.contr').length ) {
		jQuery( "a.contr" ).click(function() {
			//alert("ok");
			jQuery("body").toggleClass( "contrast" );
			jQuery.cookie( 'contrast', jQuery("body").hasClass( "contrast" ), { expires: 7, path: '/' } );
		});	
	}	

  //SUPPRESSION DES LIBELLES ENTRE {} SUR LES FICHES ANNUAIRE POUR LES DISCIPLINE
  if (jQuery('.annuaireksup .discipline .motif__contenu').length ) {
	  jQuery('.annuaireksup .discipline .motif__contenu').each(function() { 
		    var myOption = jQuery(this).text();
		    var myPos= myOption.indexOf("{");
		    var myPos2= myOption.indexOf("}");
		    if ( myPos >= 0 && myPos2 >= 0 ) {
		    	jQuery(this).text(jQuery(this).text().replace( /{\/?[\w]+}/g, ''));
		    }
	   });
  }

	
	
	
	
});